import { render, staticRenderFns } from "./PrimaryCare.vue?vue&type=template&id=8471547c&"
import script from "./PrimaryCare.vue?vue&type=script&lang=js&"
export * from "./PrimaryCare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports